import type IMonitoringSchedule from 'constants/interfaces/IMonitoringSchedule';
import type IScheduleConfigDraft from '../interfaces/IScheduleConfigDraft';

/** Builds a config-panel draft from an existing Nest/FE schedule for edit mode. */
const createScheduleConfigDraftFromSchedule = (
  schedule: IMonitoringSchedule,
): IScheduleConfigDraft => {
  const { recurrence } = schedule.schedule;

  return {
    mode: schedule.schedule.mode,
    timezone: schedule.schedule.timezone,
    recurrence: {
      frequency: recurrence.frequency,
      interval: recurrence.interval,
      daysOfWeek: recurrence.daysOfWeek ? [...recurrence.daysOfWeek] : [],
      timeOfDay: recurrence.timeOfDay,
      startDate: recurrence.startDate,
      endDate: recurrence.endDate ?? undefined,
    },
    noEndDate: recurrence.endDate == null,
    agentConfigId: schedule.agentConfigId ?? null,
    autoCreateImpactScenario: Boolean(schedule.autoCreateImpactScenario),
    impactScenarioMinSeverity: schedule.impactScenarioMinSeverity ?? null,
  };
};

export default createScheduleConfigDraftFromSchedule;
